export const MAJOR = {
  SCIENCE: 'SCIENCE',
  ART_LANG: 'ART_LANG',
  ART_MATH: 'ART_MATH',
  OTHER: 'OTHER',
};

// map university short names
// should have fetch from DB

export const universityAlias = {
  345: 'ราชภัฏบ้านสมเด็จเจ้าพระยา',
  396: 'แพทยศาสตร์พระมงกุฎฯ',
  444: 'สถาบันการพยาบาลศรีสวรินทิรา',
  331: 'มหาวิทยาลัยศรีนครินทรวิโรฒ',
  336: 'เทคโนโลยีราชมงคลกรุงเทพ',
  451: 'ม.หัวเฉียวเฉลิมพระเกียรติ',
  347: 'ราชภัฏพระนครศรีอยุธยา',
  441: 'พระจอมเกล้าพระนครเหนือ',
  323: 'ม.นราธิวาสราชนครินทร์',
  404: 'ม.ราชภัฏนครศรีธรรมราช',
  335: 'พระจอมเกล้าลาดกระบัง',
  350: 'ม.ราชภัฏวไลยอลงกรณ์ฯ',
  340: 'ม.ราชมงคลสุวรรณภูมิ',
  348: 'ม.ราชภัฏพิบูลสงคราม',
  391: 'ราชวิทยาลัยจุฬาภรณ์',
  436: 'ม.ราชภัฏอุบลราชธานี',
  351: 'ม.ราชภัฏสวนสุนันทา',
  422: 'ม.ราชภัฏนครราชสีมา',
  431: 'ราชภัฏสุราษฎร์ธานี',
  337: 'ม.ราชมงคลตะวันออก',
  349: 'ม.ราชภัฏมหาสารคาม',
  405: 'ม.ราชภัฏกาญจนบุรี',
  406: 'ม.ราชภัฏเชียงใหม่',
  408: 'ม.ราชภัฏกำแพงเพชร',
  418: 'ม.ราชภัฏจันทรเกษม',
  423: 'ม.ราชภัฏรำไพพรรณี',
  430: 'ม.ราชภัฏอุตรดิตถ์',
  447: 'ม.เทคโนโลยีมหานคร',
  338: 'ม.ราชมงคลธัญบุรี',
  346: 'ม.ราชภัฏเพชรบุรี',
  434: 'ม.ราชภัฏอุดรธานี',
  438: 'มทร.รัตนโกสินทร์',
  455: 'สถาบันการพลศึกษา',
  320: 'วิทยาลัยสุรนารี',
  339: 'ม.ราชมงคลพระนคร',
  353: 'ม.นวมินทราธิราช',
  419: 'ม.ราชภัฏชัยภูมิ',
  424: 'ราชภัฏนครสวรรค์',
  428: 'ราชภัฏบุรีรัมย์',
  415: 'ม.ราชภัฏภูเก็ต',
  416: 'ม.ราชภัฏธนบุรี',
  417: 'ม.ราชภัฏนครปฐม',
  427: 'ม.ราชภัฏสกลนคร',
  439: 'ราชภัฏสุรินทร์',
  334: 'ม.อุบลราชธานี',
  429: 'ม.ราชภัฏสงขลา',
  437: 'ราชมงคลล้านนา',
  321: 'มหาวิทยาลัยธรรมศาสตร์',
  329: 'มหาวิทยาลัยแม่ฟ้าหลวง',
  330: 'มหาวิทยาลัยวลัยลักษณ์',
  394: 'มทร.ศรีวิชัย',
  409: 'มหาวิทยาลัยราชภัฏยะลา',
  432: 'ราชภัฏพระนคร',
  440: 'ราชมงคลอีสาน',
  316: 'มหาวิทยาลัยเชียงใหม่',
  327: 'มหาวิทยาลัยมหาสารคาม',
  393: 'มหาวิทยาลัยกาฬสินธุ์',
  435: 'มหาวิทยาลัยราชภัฏลำปาง',
  352: 'มหาวิทยาลัยสวนดุสิต',
  315: 'มหาวิทยาลัยขอนแก่น',
  332: 'มหาวิทยาลัยศิลปากร',
  317: 'มหาวิทยาลัยทักษิณ',
  322: 'มหาวิทยาลัยนครพนม',
  324: 'มหาวิทยาลัยนเรศวร',
  445: 'มหาวิทยาลัยรังสิต',
  314: 'มหาวิทยาลัยเกษตร',
  318: 'มหาวิทยาลัยบางมด',
  325: 'มหาวิทยาลัย.บูรพา',
  326: 'มหาวิทยาลัยพะเยา',
  328: 'มหาวิทยาลัยมหิดล',
  333: 'มหาวิทยาลัยสงขลานครินทร์',
  313: 'จุฬาลงกรณ์มหาวิทยาลัย',
  392: 'มหาวิทยาลัยแม่โจ้',
  446: 'มหาวิทยาลัยสยาม',
};
